module.exports = __webpack_public_path__ + "static/media/approved-expert-application.e580238c.png";